import type { Messages } from '../messages'

export const bn: Messages = {
  meta: {
    title: 'বিভা শর্মা — পোর্টফোলিও',
    description:
      'ডেটা সায়েন্টিস্ট — পাওয়ার BI, SQL, পাইথন, সরকারি ও বেসরকারি খাতে বিশ্লেষণ।',
  },
  nav: {
    about: 'পরিচিতি',
    projects: 'প্রকল্প',
    experience: 'অভিজ্ঞতা',
    contact: 'যোগাযোগ',
    skipToContent: 'বিষয়বস্তুতে যান',
  },
  hero: {
    role: 'ডেটা সায়েন্টিস্ট',
    location: 'অটোয়া, অন্টারিও, কানাডা',
    tagline:
      'ডেটাকে সিদ্ধান্তে রূপান্তর — পাওয়ার BI, SQL ও NoSQL, পাইথন, পরিসংখ্যান ও ডেটা প্রস্তুতি; অর্থ, স্বাস্থ্য, কৃষি ও সরকারি খাতে।',
    ctaPrimary: 'অভিজ্ঞতা দেখুন',
    ctaSecondary: 'যোগাযোগ করুন',
  },
  about: {
    title: 'পরিচিতি',
    portraitAlt: 'বিভা শর্মার পেশাদার প্রতিকৃতি',
    lead:
      'মাইক্রোসফট পাওয়ার BI, SAP BusinessObjects ও মাইক্রোসফট BI স্ট্যাকে পাঁচ বছরের ব্যবহারিক অভিজ্ঞতায়, আমি কাঁচা ডেটাকে বিভিন্ন খাতে কার্যকর অন্তর্দৃষ্টিতে পরিণত করি।',
    p1:
      'আমি অর্থ, স্বাস্থ্যসেবা ও কৃষিতে কাজ করেছি এবং একজন ডেটা সায়েন্টিস্ট হিসেবে ডোমেইন-নির্দিষ্ট চ্যালেঞ্জ বুঝি। সম্পর্কশীল ও বহুমাত্রিক ডেটাবেস, সিস্টেম ও ডেটা ইন্টিগ্রেশন, রিপোর্টিং, বিশ্লেষণ ও দৃঢ় ডেটা ব্যবস্থাপনা আমার শক্তি।',
    p2:
      'ট্রান্সপোর্ট কানাডা, কৃষি ও কৃষি-খাদ্য কানাডা ও উইপ্রো লিমিটেডে ভূমিকা সরকারি ও বেসরকারি সংস্থায় ডেটা-ভিত্তিক সিদ্ধান্তের প্রতি আমার প্রতিশ্রুতি আরও দৃঢ় করেছে।',
    clearance:
      '২০৩০ পর্যন্ত বৈধ কানাডিয়ান রিলায়েবিলিটি ক্লিয়ারেন্স — নিরাপত্তা ও গোপনীয়তার প্রতি অঙ্গীকার।',
    stats: {
      years: '৬+ বছরের অভিজ্ঞতা',
      domains: 'অর্থ · স্বাস্থ্য · কৃষি · সরকারি খাত',
      clearanceLabel: 'রিলায়েবিলিটি ক্লিয়ারেন্স',
    },
  },
  projects: {
    title: 'প্রকল্প ও গুরুত্বপূর্ণ দিক',
    subtitle:
      'আমার ভূমিকা থেকে প্রতিনিধিত্বমূলক কাজ — ড্যাশবোর্ড, ইন্টিগ্রেশন ও বিশ্লেষণ সরবরাহ।',
    items: {
      aafc: {
        title: 'কৃষি ও সরকারি বিশ্লেষণ',
        period: '২০২৩ — বর্তমান',
        summary:
          'কৃষি ও কৃষি-খাদ্য কানাডার জন্য ডেটা সায়েন্স ও বিজনেস ইন্টেলিজেন্স — একটি বড় সরকারি সংস্থায় গবেষণা-সমন্বিত বিশ্লেষণ, রিপোর্টিং ও ডেটা সমাধান।',
        tags: 'পাওয়ার BI · ডেটা ইন্টিগ্রেশন · সরকারি খাত',
      },
      transport: {
        title: 'ট্রান্সপোর্ট কানাডা — পাওয়ার BI সরবরাহ',
        period: '২০২০ — ২০২২',
        summary:
          'পাওয়ার BI ও পাওয়ার পিভটে জটিল DAX, মডেল করা ডেটাসেট, পাওয়ার BI সার্ভিস ও রিপোর্ট সার্ভারে প্রকাশ, শেয়ারপয়েন্ট ইন্টিগ্রেশন, এবং পাওয়ারশেল ও শিড्यুলার দিয়ে স্বয়ংক্রিয় রিফ্রেশ।',
        tags: 'DAX · পাওয়ার কুয়েরি · শেয়ারপয়েন্ট · অটোমেশন',
      },
      wipro: {
        title: 'উইপ্রো — ক্রস-ইন্ডাস্ট্রি BI',
        period: '২০১৫ — ২০১৮',
        summary:
          'ভূ-স্থানিক ও স্বাস্থ্যসহ বিভিন্ন ডেটায় পাওয়ার BI ও ওয়েবি রিপোর্ট, ক্লায়েন্ট PoC, SAP BusinessObjects ইউনিভার্স ও BI পাইপলাইনের জন্য ডেটা প্রোফাইলিং।',
        tags: 'SAP BO · স্বাস্থ্য · ভূ-স্থানিক · ওয়েবি',
      },
    },
  },
  experience: {
    title: 'অভিজ্ঞতা',
    workHistory: 'কর্ম অভিজ্ঞতা',
    education: 'শিক্ষা',
    certifications: 'সার্টিফিকেশন',
    jobs: {
      aafc_ds: {
        title: 'ডেটা সায়েন্টিস্ট (স্থায়ী)',
        org: 'কৃষি ও কৃষি-খাদ্য কানাডা',
        period: 'এপ্রিল ২০২৪ — বর্তমান',
        location: 'অটোয়া, কানাডা',
        bullets: [
          'সরকারি গবেষণা ও নীতি প্রসঙ্গে ডেটা সায়েন্স ও বিশ্লেষণ।',
          'মাইক্রোসফট BI ইকোসিস্টেম ও সম্পর্কিত ডেটা প্ল্যাটফর্মে অব্যাহত সরবরাহ।',
        ],
      },
      aafc_bi: {
        title: 'ডেটা সায়েন্টিস্ট — বিজনেস ইন্টেলিজেন্স বিশেষজ্ঞ',
        org: 'কৃষি ও কৃষি-খাদ্য কানাডা',
        period: 'জুলাই ২০২৩ — এপ্রিল ২০২৪',
        location: 'অটোয়া, কানাডা',
        bullets: ['গবেষণা শাখার মধ্যে বিশেষজ্ঞ-স্তরের BI ও বিশ্লেষণ।'],
      },
      tc: {
        title: 'প্রোগ্রামার অ্যানালিস্ট',
        org: 'ট্রান্সপোর্ট কানাডা',
        period: 'জুন ২০২০ — মার্চ ২০২২',
        location: 'অটোয়া, কানাডা',
        bullets: [
          'পাওয়ার BI ও পাওয়ার পিভটের জন্য উন্নত DAX; কম্পিউটেড টেবিল ও সমৃদ্ধ ভিজ্যুয়াল।',
          'পাওয়ার BI সার্ভিস ও রিপোর্ট সার্ভারে প্রকাশ; শেয়ারপয়েন্ট অনলাইন অ্যাক্সেস।',
          'পাওয়ারশেল ও উইন্ডোজ টাস্ক শিড्यুলারের মাধ্যমে পাওয়ার কুয়েরি রিফ্রেশ স্বয়ংক্রিয়।',
        ],
      },
      wipro: {
        title: 'ডেটা সায়েন্টিস্ট',
        org: 'উইপ্রো লিমিটেড',
        period: 'ডিসেম্বর ২০১৫ — আগস্ট ২০১৮',
        location: 'গুড়গাঁও, ভারত',
        bullets: [
          'ভূ-স্থানিক ও স্বাস্থ্যসহ বিভিন্ন ডেটায় পাওয়ার BI ও ওয়েবি।',
          'ক্লায়েন্ট PoC, ডেটা ওয়্যারহাউস থেকে SAP BO ইউনিভার্স, ও BI-র জন্য ডেটা প্রোফাইলিং।',
        ],
      },
    },
    edu: {
      masters: {
        degree: 'মাস্টার্স ডিগ্রি, তথ্য প্রযুক্তি',
        school: 'অটোয়া বিশ্ববিদ্যালয়',
        period: '২০১৮ — ২০২০',
        detail: 'কানাডা',
      },
      bachelors: {
        degree: 'স্নাতক ডিগ্রি, তথ্য প্রযুক্তি',
        school: 'চণ্ডীগড় ইঞ্জিনিয়ারিং কলেজ, লন্দ্রান',
        period: '২০১১ — ২০১৫',
      },
    },
    certs: {
      pbi: {
        name: 'পাওয়ার BI এসেনশিয়াল ট্রেনিং',
        issuer: 'লিঙ্কডইন লার্নিং',
        issued: 'অক্টোবর ২০২২',
      },
      ssis: {
        name: 'SQL সার্ভার ইন্টিগ্রেশন সার্ভিসেস',
        issuer: 'লিঙ্কডইন লার্নিং',
        issued: 'অক্টোবর ২০২২',
      },
    },
  },
  contact: {
    title: 'যোগাযোগ',
    subtitle:
      'ডেটা, বিশ্লেষণ বা সহযোগিতার সুযোগ নিয়ে কথা বলতে আমি আগ্রহী।',
    emailLabel: 'ইমেইল',
    linkedinLabel: 'লিঙ্কডইন',
    locationLabel: 'অবস্থান',
    formNote: 'ইমেইল বা লিঙ্কডইনের মাধ্যমে যোগাযোগ করুন — সম্ভব হলে আমি উত্তর দেব।',
  },
  footer: {
    rights: '© বিভা শর্মা।',
    builtWith: 'React ও Vite দিয়ে তৈরি',
  },
  controls: {
    theme: 'থিম',
    themeLight: 'লাইট',
    themeDark: 'ডার্ক',
    themeEnhanced: 'উন্নত ডার্ক',
    language: 'ভাষা',
  },
}
